<template>
  <flat-pickr v-model="date" class="datepicker" />
</template>

<script lang="ts">
import flatPickr from 'vue-flatpickr-component';
import { defineComponent, onMounted, ref } from "vue"

export default defineComponent({
  name: 'DatePickerEditor',
  components: {
    flatPickr
  },
  setup(props: any) {
    const date =  ref("");

    const getValue = () => {
      return date.value.replaceAll("-", "");
    };

    onMounted(() => {
      const value = props.params.value;
      if (value && value.length === 8) {
        date.value = value.substring(0, 4) + "-" + value.substring(4, 6) + "-" + value.substring(6);
      }
    });

    return {
      date,
      getValue,
    }
  },
});

</script>

<style>
.datepicker {
  width: 100%;
}
</style>